import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { COLORS } from '../marketingLeadConstants';

export const CURRENT_STATUS_OPTIONS = [
  { value: 'not_onboarded_yet', label: 'Not onboarded yet' },
  { value: 'onboarding_in_progress', label: 'Onboarding in progress' },
  { value: 'onboarded', label: 'Onboarded' },
  { value: 'onboarding_failed', label: 'Onboarding failed' },
  { value: 'contacted_restaurant', label: 'Contacted restaurant' },
  { value: 'meeting_scheduled', label: 'Meeting scheduled' },
];

export function UpdateLeadModal({ modal, onChange, onClose, onSubmit }) {
  return (
    <Dialog
      open={modal.open}
      onClose={() => { if (!modal.submitting) onClose(); }}
      fullWidth
      maxWidth='sm'
      PaperProps={{
        sx: {
          borderRadius: '16px',
          border: '1px solid #E8E8E8',
          boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
        },
      }}
    >
      <DialogTitle sx={{ fontFamily: 'Inter Bold, sans-serif', fontWeight: 700, fontSize: 16, color: '#111111' }}>
        Update Lead
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography sx={{ fontFamily: 'Inter Regular, sans-serif', fontSize: 13, color: COLORS.muted }}>
            Update marketing fields for <b>{modal.row?.name || 'this lead'}</b>.
          </Typography>

          <FormControl size='small' fullWidth>
            <InputLabel id='marketing-current-status-label'>Current status</InputLabel>
            <Select
              labelId='marketing-current-status-label'
              label='Current status'
              value={modal.currentStatus}
              onChange={(e) => onChange((prev) => ({ ...prev, currentStatus: String(e.target.value), error: '' }))}
            >
              {CURRENT_STATUS_OPTIONS.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            size='small'
            label='Marketing notes'
            multiline
            minRows={3}
            value={modal.marketingNotes}
            onChange={(e) => onChange((prev) => ({ ...prev, marketingNotes: e.target.value, error: '' }))}
          />

          <FormControl size='small' fullWidth>
            <InputLabel id='marketing-sms-sent-label'>SMS sent</InputLabel>
            <Select
              labelId='marketing-sms-sent-label'
              label='SMS sent'
              value={modal.smsSent ? 'yes' : 'no'}
              onChange={(e) =>
                onChange((prev) => ({ ...prev, smsSent: String(e.target.value) === 'yes', error: '' }))
              }
            >
              <MenuItem value='yes'>Yes</MenuItem>
              <MenuItem value='no'>No</MenuItem>
            </Select>
          </FormControl>

          {modal.error ? (
            <Typography sx={{ color: '#dc2626', fontSize: 13, fontFamily: 'Inter Regular, sans-serif' }}>
              {modal.error}
            </Typography>
          ) : null}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button
          disabled={modal.submitting}
          onClick={onClose}
          sx={{ textTransform: 'none', color: '#8C8C8C', fontFamily: 'Inter Regular, sans-serif' }}
        >
          Cancel
        </Button>
        <Button
          disabled={modal.submitting}
          onClick={onSubmit}
          variant='contained'
          sx={{
            textTransform: 'none',
            fontFamily: 'Inter Bold, sans-serif',
            bgcolor: '#111111',
            boxShadow: 'none',
            borderRadius: '8px',
            '&:hover': { bgcolor: '#333333', boxShadow: 'none' },
            '&.Mui-disabled': { bgcolor: '#E8E8E8', color: '#8C8C8C' },
          }}
        >
          {modal.submitting ? 'Updating...' : 'Update Lead'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
